import { createSelector } from 'reselect';

const selectEApplications = (state: any) => state.eApplications;


export const selectEApplicationsCurrentItem = createSelector([selectEApplications], (eApplications) => eApplications.current);

export const selectEApplicationsListItems = createSelector([selectEApplications], (eApplications) => eApplications.list);

export const selectEApplicationsItemById = (itemId: any) =>
    createSelector(selectEApplicationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEApplicationsQueryItems = createSelector([selectEApplications], (eApplications) => eApplications.query);

export const selectEApplicationsCreatedItem = createSelector([selectEApplications], (eApplications) => eApplications.create);

export const selectEApplicationsUpdatedItem = createSelector([selectEApplications], (eApplications) => eApplications.update);

export const selectEApplicationsReadItem = createSelector([selectEApplications], (eApplications) => eApplications.read);

export const selectEApplicationsDeletedItem = createSelector([selectEApplications], (eApplications) => eApplications.delete);

export const selectEApplicationsSearchedItems = createSelector([selectEApplications], (eApplications) => eApplications.search);

export const selectEApplicationsItemsCount = createSelector([selectEApplications], (eApplications) => eApplications.count);

export const selectEApplicationsItemsFilter = createSelector([selectEApplications], (eApplications) => eApplications.filter);